import { render, staticRenderFns } from "./DispatchCode.vue?vue&type=template&id=266728f0&scoped=true&"
import script from "./DispatchCode.vue?vue&type=script&lang=js&"
export * from "./DispatchCode.vue?vue&type=script&lang=js&"
import style0 from "./DispatchCode.vue?vue&type=style&index=0&id=266728f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266728f0",
  null
  
)

export default component.exports